<script lang="ts">
  import Alwan from 'alwan';
  import {createEventDispatcher, onMount} from 'svelte';

  const dispatch = createEventDispatcher();
  export let color: string;
  export let colors: string[];

  let dom: HTMLElement;
  let pickerElement: HTMLElement;

  $: if (dom && color) dom.style.backgroundColor = color;

  function openColorPicker() {
    let brandKitColors = [];

    if (window.brandKit) {
      brandKitColors = [window.brandKit.color1, window.brandKit.color2, window.brandKit.color3].filter(
        item => item !== null
      );
    }

    const picker = new Alwan(pickerElement, {
      color,
      swatches: [...brandKitColors, ...colors]
    });

    picker.open();

    picker.on('change', (c: any) => {
      color = c.hex as string;
      dispatch('color-change', {color});
    });

    picker.on('close', () => {
      picker.destroy();
    });
  }
</script>

{#if color}
  <div
    class="relative flex-grow cursor-pointer p-2"
    bind:this={dom}
    on:keydown={openColorPicker}
    on:click={openColorPicker}
  >
    <div class="absolute left-5 top-2" bind:this={pickerElement} />
  </div>
{/if}
